import { IPersonProfessional } from './iperson-professional';

export interface IPersonProfessionalState {
  personProfessional: IPersonProfessional;
  personProfessionals: IPersonProfessional[];
  error?: any;
  idPerson: number;
}
